import HexController from 'controllers/hex_controller';
import { v4 as uuidv4 } from 'uuid';

export default class extends HexController {
  static targets = ['deleteButton', 'hiddenSubmitButton'];

  connect() {
    this.deleteButtonTarget.addEventListener('click', this.deleteScriptClicked.bind(this));
    this.hiddenSubmitButtonTarget.addEventListener('click', this.submitForm.bind(this));
  }

  disconnect() {
    this.deleteButtonTarget.removeEventListener('click', this.deleteScriptClicked.bind(this));
    this.hiddenSubmitButtonTarget.removeEventListener('click', this.submitForm.bind(this));
  }

  deleteScriptClicked(event) {
    event.stopPropagation();
    event.preventDefault();
    if (window.navigationLockController?._locking) {
      const funcName = uuidv4();
      window[funcName] = () => {
        this.deleteButtonTarget.click();
      };
      window.navigationLockController?.showWarningDialog(null, `window['${funcName}']()`);
      return;
    }
    this._confirmDeleteModal();
  }

  _confirmDeleteModal() {
    const funcName = `MS_delete_${uuidv4()}`;

    window[funcName] = () => {
      window.navigationLockController?.unlock();
      this.element.closest('form').submit();
      window[funcName] = null;
    };

    const title = this.t('Manual Script');
    const footer = `<button class='btn' onclick="Modalbox.hide()">${this.t('Cancel')}</button>` +
                   `<button class='btn btn-danger' onclick="window['${funcName}']();">${this.t('Delete')}</button>`;
    const options = {
      title: title,
      width: 700,
      center: true,
      transitions: false,
      defaultFooter: true,
      footer: footer,
      // containerClass: 'no-container-padding'
    };
    const body = `<div>${this.t('Are you sure you would like to delete this script?')}</div>`;
    Modalbox.show(body, options, footer);
  }

  submitForm(event) {
    event.stopPropagation();
  }
}